import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, onSnapshot, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import './Countdowns.css';

const Countdowns = () => {
    const [user, setUser] = useState(null);
    const [coupleData, setCoupleData] = useState({ countdowns: [] });
    const [title, setTitle] = useState('');
    const [date, setDate] = useState('');
    const [coupleId, setCoupleId] = useState(null);
    const [timeLefs, setTimeLefts] = useState({});

    useEffect(() => {
        const unsubAuth = auth.onAuthStateChanged(currentUser => {
            if (currentUser) {
                const userDocRef = doc(db, 'users', currentUser.uid);
                const unsubUser = onSnapshot(userDocRef, (docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        setUser(userData);
                        if (userData.partnerId) {
                            const ids = [currentUser.uid, userData.partnerId].sort();
                            setCoupleId(ids.join('_'));
                        }
                    }
                });
                return () => unsubUser();
            } else {
                setUser(null);
                setCoupleId(null);
            }
        });
        return () => unsubAuth();
    }, []);

    useEffect(() => {
        if (!coupleId) return;
        const coupleDocRef = doc(db, 'coupleData', coupleId);
        const unsubscribe = onSnapshot(coupleDocRef, (docSnap) => {
            if (docSnap.exists()) {
                setCoupleData(docSnap.data());
            } else {
                setCoupleData({ countdowns: [] });
            }
        });
        return () => unsubscribe();
    }, [coupleId]);

    const handleAddCountdown = async (e) => {
        e.preventDefault();
        if (title && date && coupleId) {
            const newCountdown = {
                id: `countdown_${Date.now()}`,
                title,
                date,
                createdAt: new Date().toISOString()
            };
            const coupleDocRef = doc(db, 'coupleData', coupleId);
            await updateDoc(coupleDocRef, {
                countdowns: arrayUnion(newCountdown)
            }, { merge: true });
            setTitle('');
            setDate('');
        }
    };

    const handleDeleteCountdown = async (countdown) => {
        if (!coupleId) return;
        const coupleDocRef = doc(db, 'coupleData', coupleId);
        await updateDoc(coupleDocRef, {
            countdowns: arrayRemove(countdown)
        });
    };

    const calculateTimeLeft = (endDate) => {
        const difference = +new Date(endDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLefts = {};
            if (coupleData.countdowns) {
                coupleData.countdowns.forEach(c => {
                    newTimeLefts[c.id] = calculateTimeLeft(c.date);
                });
            }
            setTimeLefts(newTimeLefts);
        }, 1000);

        return () => clearInterval(timer);
    }, [coupleData.countdowns]);

    if (!user) {
        return <div className="countdowns-container"><p>Please log in to see your countdowns.</p></div>;
    }
    if (!user.partnerId) {
        return <div className="countdowns-container"><p>Please link with a partner to use countdowns.</p></div>;
    }

    return (
        <div className="countdowns-container">
            <h1>Countdowns</h1>
            <form onSubmit={handleAddCountdown} className="countdown-form">
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Countdown Title"
                    required
                />
                <input
                    type="datetime-local"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    required
                />
                <button type="submit">Add Countdown</button>
            </form>
            <div className="countdowns-list">
                {coupleData.countdowns && [...coupleData.countdowns].sort((a, b) => new Date(a.date) - new Date(b.date)).map(countdown => {
                    const timeLeft = timeLefs[countdown.id];
                    return (
                        <div key={countdown.id} className="countdown-item">
                            <h3>{countdown.title}</h3>
                            {timeLeft && (timeLeft.days || timeLeft.hours || timeLeft.minutes || timeLeft.seconds) ? (
                                <div className="countdown-timer">
                                    <span>{timeLeft.days}d </span>
                                    <span>{timeLeft.hours}h </span>
                                    <span>{timeLeft.minutes}m </span>
                                    <span>{timeLeft.seconds}s</span>
                                </div>
                            ) : <p>The time has come!</p>}
                            <button onClick={() => handleDeleteCountdown(countdown)}>Delete</button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Countdowns;
